  const numberOfVisibleReviews = 2;

  function getElementFullWidth(el, index) {
      const gap = $('.trustpilot-wrapper .trustpilot-carousel').css('gap');
      let numberOfElements = 2;
      if( $(window).width() < 750  ) { 
          numberOfElements = 1;
      }
      const moveVal = ($('.trustpilot-wrapper').width() + parseInt(gap)) / numberOfElements;
      return moveVal * index;
  }

  function moveLeft() { 
      const carouselContainer = $('.trustpilot-carousel');
      const activeEl = $('.trustpilot-review.active');
      const reviewEl = $('.trustpilot-review');
      let activeIndex = activeEl.index();
      let prevIndex = activeIndex - 1;
      if( prevIndex <= -1 ) prevIndex = reviewEl.length - numberOfVisibleReviews;
      activeEl.removeClass('active');
      reviewEl.eq(prevIndex).addClass('active');

      const moveValue = getElementFullWidth(activeEl, prevIndex)
      carouselContainer.css('left', -moveValue)
  }

  function moveRight() { 
      const carouselContainer = $('.trustpilot-carousel');
      const activeEl = $('.trustpilot-review.active');
      const reviewEl = $('.trustpilot-review');
      let activeIndex = activeEl.index();
      let nextIndex = activeIndex + 1;
      if( nextIndex >= (reviewEl.length + 1) - numberOfVisibleReviews ) nextIndex = 0;
      activeEl.removeClass('active');
      reviewEl.eq(nextIndex).addClass('active');

      const moveValue = getElementFullWidth(activeEl, nextIndex);
      carouselContainer.css('left', -moveValue)
  }

  function trustpilotSummary() {
      let starsHtml = '';
      let starsHtmlMedium = '';
      const summary = { 
          score: { 
              stars: 4.5
          }
      }
      if( !summary ) return; 
      let halfStarIndex = null;
      if( summary.score.stars % 1 != 0 ) { 
          halfStarIndex = parseInt(summary.score.stars);
      }

      for( let i = 0; i < parseInt(summary.score.stars); i++ ) { 
          starsHtml += '<img style="margin:0 1px;" class="d-inline" src="https://cdn.shopify.com/s/files/1/0566/6760/3062/files/trustpilot-single-star-active.svg?v=1707757966" />';
          starsHtmlMedium += '<img style="max-height: 25px; margin:0 1px;" class="d-inline" src="https://cdn.shopify.com/s/files/1/0566/6760/3062/files/trustpilot-single-star-active.svg?v=1707757966" />';
      }
      for( let i = 0; i < ( 5 - parseInt(summary.score.stars) ); i++ ) { 
          const imageSrc = halfStarIndex && i == 0 ? 'https://cdn.shopify.com/s/files/1/0566/6760/3062/files/trustpilot-single-star-half-active.svg?v=1707757966' : 'https://cdn.shopify.com/s/files/1/0566/6760/3062/files/trustpilot-single-star-inactive.svg?v=1707757966';
          starsHtml += '<img style="margin:0 1px;" class="d-inline" src="'+imageSrc+'" />';
          starsHtmlMedium += '<img style="max-height: 25px; margin:0 1px;" class="d-inline" src="'+imageSrc+'" />';
      }
      $('[trustpilot-stars]').html(starsHtml)
      $('[trustpilot-stars-medium]').html(starsHtmlMedium)
  }

  function initTrustpilotCarousel() {
      let reviewsHtml = '';
      let firstReviewHtml = '';
      const reviews = [
          {
              title: "I’d never tried Hypnotherapy before...",
              text: "I’d never tried Hypnotherapy before this and was very sceptical, but the changes I’ve felt since trying this are undoubted and now I’m recommending my friends try it too! It feels like a cheat code to living a happier life",
              name: "Doug",
              created_at: "1 Feb 2024",
              stars: 5,
          },
          {
              title: "I’m 90% better",
              text: "The more I listened to the sessions the calmer l felt. Now I’m 90% better. Thank you for giving my life back. I would strongly recommend New Mindset Hypnotherapy to anyone who has high anxiety and depression.",
              name: "Sherri",
              created_at: "26 Jan 2024",
              stars: 5,
          },
          {
              title: "I was sceptical about hypnotherapy",
              text: "I was sceptical about hypnotherapy but also desperately wanted to change. Three days in and I cannot believe the transformation. I had a query which was answered quickly and efficiently and I can not recommend this highly enough. If you are unsure, just do it.",
              name: "Alison",
              created_at: "22 Jan 2024",
              stars: 5,
          },
      ];

      reviews.forEach(function(review, index) { 
          const activeClass = index == 0 ? 'active' : '';
          reviewsHtml += '<div class="trustpilot-review '+ activeClass +'">' +
              '<div class="trustpilot-review-top">' +
                  '<img width="100" src="https://cdn.shopify.com/s/files/1/0566/6760/3062/files/trustpilot-stars-small-'+ review.stars +'.svg" />' +
                  '<span class="trustpilot-time">'+ review.created_at +'</span>' +
              '</div>' +
              '<div class="trustpilot-content">' +
                  '<span class="trustpilot-title"><b>'+ review.title +'</b></span>' +
                  '<p class="trustpilot-description">'+ review.text +'</p>' +
                  '<span class="trustpilot-person">'+ review.name +'</span>' +
              '</div>' +
          '</div>';
          if( index == 0 ) firstReviewHtml = reviewsHtml;
      })

      reviewsHtml += firstReviewHtml;
      $('.trustpilot-carousel').html(reviewsHtml);
      $('.trustpilot-arrow').show();
      $('.trustpilot-loading').hide();
  }

  jQuery(document).ready(function(){
      initTrustpilotCarousel();
      trustpilotSummary();

      $('.trustpilot-arrow').click(function() {
          // Prevent Click Before API Request Load
          const activeEl = $('.trustpilot-review.active');
          if( activeEl.length > 0 ) { 
              if( $(this).attr('class').includes('left') ) { 
                  moveLeft();
              } else {
                  moveRight();
              }
          }
      })
  })
  jQuery(window).resize(function() { 
      $('.trustpilot-review').removeClass('active');
      $('.trustpilot-review').eq(0).addClass('active');
      $('.trustpilot-carousel').css('left', 0)
  })